var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackedSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480,458.31v-60q-240,4.23-480,0v60Q240,462.53,480,458.31Z",
    opacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480,366.77v-60q-239.88,10.58-480,0v60Q239.88,377.24,480,366.77Z",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M480,248.53V188.29a2730.62,2730.62,0,0,1-480,0v60.24A2789.8,2789.8,0,0,0,480,248.53Z",
    opacity: 0.85
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M480,92.19V31.39a1452,1452,0,0,1-480,0v60.8A1512.22,1512.22,0,0,0,480,92.19Z",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedSquare);
export default __webpack_public_path__ + "static/media/StackedSquare.6542ecb0c65ad236e07cb2033b1ccc70.svg";
export { ForwardRef as ReactComponent };